import Button from 'components/shared/Button.styled';
import styled from 'styled-components';
import { container, fontSize, spacing } from '../../../theme';
import { Heading1 } from '../../shared/Typography';

export const StyledDaily = styled.div`
  margin-top: ${spacing('xl4')};
  overflow-x: hidden;
`;

export const StyledDailyHero = styled.div`
  max-width: ${container('md')};
  margin: 0 auto ${spacing('xl4')};
  text-align: center;
  font-size: ${fontSize('lg')};

  ${Heading1} {
    margin-bottom: ${spacing('xl')};
  }

  ${Button} {
    margin-top: ${spacing('xl')};
  }
`;
